import { useQuery } from "@tanstack/react-query";
import { SectionHeading } from "@/components/bespoke/section-heading";
import { Card, CardContent } from "@/components/ui/card";
import { qualityMetricsQuery } from "@/lib/api";
import { qualityMetricTiles } from "@/lib/quality-metrics";

/** Quality and cost metrics for the Evals page (QA20). Read only. */
export function QualityMetricsPanel({ projectId }: { projectId: string }) {
  const query = useQuery(qualityMetricsQuery(projectId));

  return (
    <section aria-labelledby="quality-metrics-heading" className="mb-6">
      <SectionHeading id="quality-metrics-heading" className="mb-3">
        Quality metrics
      </SectionHeading>
      {query.isPending ? (
        <p className="text-sm text-muted-foreground">Loading metrics</p>
      ) : query.isError || !query.data ? (
        <p className="text-sm text-muted-foreground">Quality metrics are unavailable right now.</p>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {qualityMetricTiles(query.data).map((tile) => (
            <Card key={tile.label}>
              <CardContent className="p-4">
                <p className="text-sm text-muted-foreground">{tile.label}</p>
                <p className="mt-1 text-2xl font-semibold">{tile.value}</p>
                <p className="mt-1 text-xs text-muted-foreground">{tile.detail}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
